import React from 'react';
import styled from "styled-components";
import useZibi from "../../../zibi/UseZibi";
import Camera from "./Camera";
import {useLocation} from "react-router-dom";
import {getQueryValue} from "../../../domain/queryHandler";

const WrapperStyled = styled.div`
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    display: grid;
    grid-gap: 15px;
`;

const Cameras = () => {
    const location = useLocation();

    const edgeId = getQueryValue(location, 'edge');

    const [siteCameras] = useZibi('siteCameras');

    const listOfCameras = Object.values(siteCameras);

    const filtered = edgeId ? listOfCameras.filter(field => field.edgeId === edgeId): listOfCameras;

    return (
        <WrapperStyled>
            {filtered && filtered.map((cam) => {
                return (
                    <Camera
                        key={cam._id}
                        item={cam}
                    />
                );
            })}
        </WrapperStyled>
    );
};

export default Cameras;